/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_OptionsInputs */

const en_pricing_options = /** @type {(inputs: Pricing_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pricing options`)
};

const es_pricing_options = /** @type {(inputs: Pricing_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opciones de precios`)
};

/**
* | output |
* | --- |
* | "Pricing options" |
*
* @param {Pricing_OptionsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pricing_options = /** @type {((inputs?: Pricing_OptionsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_OptionsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_pricing_options(inputs)
	return en_pricing_options(inputs)
});